<footer class="w-full bg-white mt-10">
  <div class="max-w-7xl px-6 pt-8 mx-auto">
    <!-- Main Footer Grid -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
      <!-- Column 1 -->
      <div class="space-y-6">
        <img
          src="./assets/images/brand/orbit-dark-logo.webp"
          alt="Orbit Logo"
          loading="lazy"
          (click)="goTo('/')"
          class="h-12 sm:h-16 lg:h-20 w-auto cursor-pointer" />
        <p class="text-sm sm:text-base text-gray-700 leading-relaxed font-sans ">
          ORBIT – Office ERP empowers businesses with smarter workflows,
          seamless collaboration, and higher productivity—all in one integrated
          solution.
        </p>

        <!-- Language Dropdown -->
        <div>
          <select
            id="options"
            class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-gray-900 shadow-sm focus:border-blue-500 focus:ring focus:ring-blue-200 sm:text-sm font-sans "
            [(ngModel)]="selectedOption">
            <option *ngFor="let option of options" [value]="option">
              {{ option }}
            </option>
          </select>
        </div>
      </div>

      <!-- Column 2 -->
      <div class="space-y-3">
        <h3 class="font-semibold text-lg font-sans">Company</h3>
        <ul class="space-y-2 text-sm sm:text-base text-gray-700">
          <li (click)="goTo('/about-us')" class="cursor-pointer font-sans">Who We Are</li>
          <!--<li (click)="goTo('/pricing-plans')" class="cursor-pointer">Pricing & Plans</li>
          <li (click)="goTo('/features')" class="cursor-pointer">Features</li>
          <li (click)="goTo('/blogs')" class="cursor-pointer">Blogs</li>
          <li (click)="goTo('/refund-policy')" class="cursor-pointer">Refund Policy</li>-->
        </ul>
      </div>

      <!-- Column 3 -->
      <div class="space-y-3">
        <h3 class="font-semibold text-lg font-sans">Contact Us</h3>
        <p>
          <a href="tel:+919310828501" class="hover:underline text-gray-700"
            >+91 9310828501</a
          >
        </p>
        <p>
          <a
            href="mailto:support@volmint.com"
            class="hover:underline text-gray-700"
            >support&#64;volmint.com</a
          >
        </p>
        <p class="text-sm sm:text-base text-gray-700">
          29/2, Vijay Enclave, Dwarka-Palam Road, Delhi-110045
        </p>
      </div>

      <!-- Column 4 -->
      <div class="space-y-3">
        <h3 class="font-semibold text-lg font-sans">Follow Us</h3>
        <ul class="space-y-2 text-sm sm:text-base text-gray-700">
          <li class="flex items-center">
            <i class="fa-brands fa-instagram me-2"></i
            ><a
              href="https://www.instagram.com/volminttechnologies/"
              target="_blank" class="font-sans "
              >Instagram</a
            >
          </li>
          <li class="flex items-center">
            <i class="fa-brands fa-x-twitter me-2"></i
            ><a
              href="https://x.com/i/flow/login?redirect_after_login=%2FTechVolmint"
              target="_blank" class="font-sans "
              >Twitter</a
            >
          </li>
          <li class="flex items-center">
            <i class="fa-brands fa-linkedin-in me-2"></i
            ><a
              href="https://www.linkedin.com/company/volmint-technologies/"
              target="_blank" class="font-sans "
              >LinkedIn</a
            >
          </li>
          <li class="flex items-center">
            <i class="fa-brands fa-facebook me-2"></i
            ><a
              href="https://www.facebook.com/VolmintTechnologies"
              target="_blank" class="font-sans "
              >Facebook</a
            >
          </li>
          <li class="flex items-center">
            <i class="fa-brands fa-youtube me-2"></i
            ><a
              href="https://www.youtube.com/@volminttechnologies"
              target="_blank" class="font-sans "
              >YouTube</a
            >
          </li>
        </ul>
      </div>
    </div>

    <!-- Bottom Bar -->
    <div
      class="relative flex flex-col mt-10 h-[200px] bg-no-repeat bg-center bg-contain"
      style="
        background-image: url(assets/images/volmint-footer.png);
      ">
      <!-- Spacer to push content down -->
      <div class="flex-1"></div>

      <!-- Divider -->
      <hr class="" />

      <!-- Bottom Row -->
      <div
        class="flex flex-1 flex-col sm:flex-row items-center justify-between px-4 text-sm sm:text-base text-gray-600">
        <p
          class="mb-2 sm:mb-0 text-center sm:text-left font-sans "
          (click)="openUrl('https://volmint.com')">
          © Copyright 2025. All rights reserved.
        </p>
        <p class="flex gap-2 sm:gap-4 text-center sm:text-right">
          <a (click)="goTo('/terms-conditions')" class="hover:underline"
            >Terms & Conditions</a
          >
          |
          <a href="#" class="hover:underline">Privacy Policy</a>
        </p>
      </div>
    </div>
  </div>
</footer>
